module.exports = "<span class=\"example-pizza-party\">\n  Pizza party!!! 🍕\n</span>\n"